// extracted by mini-css-extract-plugin
export default {"modalHeader":"EmailModal_modalHeader__g6fz5","title":"EmailModal_title__2k9wa","modalBody":"EmailModal_modalBody__-Koxj"};